export const GS_DOMAIN = 'gostudent.org';
